export default {
  namespaced: true,

  state: {
    cart: [],
    moltiplier: null,
  },

  getters: {
    isInCart: ({ cart }) => productId => cart.some(({ product: { Id } }) => Id === productId),
    idxCartFromId: ({ cart }) => productId => cart.findIndex(({ product: { Id } }) => Id === productId),
    getItemFromCart: ({ cart }) => productId => cart.find(({ product: { Id } }) => Id === productId),

    movements: ({ cart }) => cart.map(({ product, qty, price: PrezzoTotale }) => ({
      Descrizione: product.label,
      Prezzo: product.Prezzo,
      Iva: product.Iva,
      qty,
      PrezzoTotale,
      productId: String(product.Id).includes('-') ? null : product.Id,
    })),

    // TODO: da rivedere le formule di scorporo iva.
    getTaxable: ({ cart }) => cart.reduce((total, { price, product }) => total + (price / (product.Iva / 100 + 1)), 0),
    getTax: ({ cart }) => cart.reduce((total, { price, product }) => total + (price / (product.Iva / 100 + 1) * product.Iva / 100), 0),
    getTotal: ({ cart }) => cart.reduce((total, { price }) => total + price, 0),
  },

  actions: {
    addToCart({ state: { cart, moltiplier }, commit, getters: { isInCart, idxCartFromId } }, { ...product }) { // COPY ?
      if (isInCart(product.Id)) {
        const idx = idxCartFromId(product.Id)
        const qty = cart[idx].qty + Number(moltiplier || 1)
        commit('updateQty', { idx, qty })
      } else commit('ADD_TO_CART', product)
      commit('setMoltiplier', null)
    },
    removeItemFromCart({ commit, getters: { isInCart, idxCartFromId } }, productId) {
      if (isInCart(productId)) {
        const idx = idxCartFromId(productId)
        commit('REMOVE_FROM_CART', idx)
      }
    },
    removeFromCart({ state: { cart }, commit, getters: { isInCart, idxCartFromId } }, productId) {
      if (isInCart(productId)) {
        const idx = idxCartFromId(productId)
        const qty = cart[idx].qty
        if (qty === 1) commit('REMOVE_FROM_CART', idx)
        else commit('updateQty', { idx, qty: qty - 1 })
      }
    },
  },

  mutations: {
    ADD_TO_CART({ cart, moltiplier }, product) {
      const qty = Number(moltiplier || 1)
      const price = product.Prezzo * qty
      cart.push({ product, qty, price })
    },
    REMOVE_FROM_CART(state, idx) {
      state.cart.splice(idx, 1)
    },

    updateQty({ cart }, { idx, qty }) {
      cart[idx].qty = Number(qty)
      cart[idx].price = cart[idx].product.Prezzo * qty
    },
    updatePrice({ cart }, { idx, Prezzo }) {
      cart[idx].product.Prezzo = Number(Prezzo)
      cart[idx].price = Prezzo * cart[idx].qty
    },
    updateIva({ cart }, { idx, Iva }) {
      cart[idx].product.Iva = Iva
    },
    updateLabel({ cart }, { idx, label }) {
      cart[idx].product.label = label
    },

    setMoltiplier(state, moltiplier) {
      state.moltiplier = moltiplier
    },
    clear(state) {
      state.cart = []
      state.moltiplier = null
    },
  },
}
